import { render, staticRenderFns } from "./feed-list-item.vue?vue&type=template&id=eba2f524&scoped=true&"
import script from "./feed-list-item.vue?vue&type=script&lang=js&"
export * from "./feed-list-item.vue?vue&type=script&lang=js&"
import style0 from "./feed-list-item.vue?vue&type=style&index=0&id=eba2f524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba2f524",
  null
  
)

export default component.exports